import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { Collection } from '@/features/collections/types/collection.interface';
import type { Dataset } from '@/features/datasets/interfaces/dataset.interface';

interface DashboardState {
  sessionToken: string;
  selectedSpaceTab: string;
  selectedUsersTab: string;
  isCreateLoading: boolean;
  actualDataset: Dataset;
  actualCollection: Collection;
  breadcrumbs: Array<{ name: string; level: string; linkTo: string }>;

  setSessionToken: (token: string) => void;
  setSelectedSpaceTab: (tab: string) => void;
  setSelectedUsersTab: (tab: string) => void;
  setIsCreateLoading: (loading: boolean) => void;
  setActualDataset: (dataset: Dataset) => void;
  setActualCollection: (collection: Collection) => void;
  setBreadcrumbs: (breadcrumbs: Array<{ name: string; level: string; linkTo: string }>) => void;
}

export const useDashboardStore = create<DashboardState>()(
  persist(
    (set) => ({
      sessionToken: '',
      selectedSpaceTab: 'private-space',
      selectedUsersTab: 'users',
      isCreateLoading: false,
      actualDataset: {} as Dataset,
      actualCollection: {} as Collection,
      breadcrumbs: [],

      setSessionToken: (token) => set(() => ({ sessionToken: token })),
      setSelectedSpaceTab: (tab) => set(() => ({ selectedSpaceTab: tab })),
      setSelectedUsersTab: (tab) => set(() => ({ selectedUsersTab: tab })),
      setIsCreateLoading: (loading) => set(() => ({ isCreateLoading: loading })),
      setActualDataset: (dataset) => set(() => ({ actualDataset: dataset })),
      setActualCollection: (collection) => set(() => ({ actualCollection: collection })),
      setBreadcrumbs: (breadcrumbs) => set(() => ({ breadcrumbs })),
    }),
    {
      name: 'dashboard-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        sessionToken: state.sessionToken,
        selectedSpaceTab: state.selectedSpaceTab,
        selectedUsersTab: state.selectedUsersTab,
        actualDataset: state.actualDataset,
        actualCollection: state.actualCollection,
        breadcrumbs: state.breadcrumbs,
      }),
    },
  ),
);
